import React from "react";
import IdentityPapersInfo from "./IdentityPapersInfo";

interface IdentityPapersProps {
  form: any;
}

const IdentityPapers = ({ form }: IdentityPapersProps) => {
  return (
    <div style={{ padding: "2rem" }}>
      <IdentityPapersInfo form={form} />
    </div>
  );
};

export default IdentityPapers;
